<script setup>
import ModalWindowBase from "@/components/UI/ModalWindowBase.vue";
import {computed, defineModel, onBeforeMount, ref, watchEffect} from 'vue'
import {Api} from "@/service/api";
import {useRoute} from "vue-router";


const isVisible = defineModel('is-visible')
const connection_id = defineModel('connection-id')
const refreshTrigger = defineModel('refresh-trigger')

const connections = ref([])

const route = useRoute()


const connection = computed(() => {
    return connections.value.find(connection => connection.id === connection_id.value)
})

watchEffect(async () => {
    if (refreshTrigger.value === true) {
        connections.value = await Api.getWorkflowConnections(route.params.workflow_id)
        refreshTrigger.value = false
    }
})

onBeforeMount(async () => {
    connections.value = await Api.getWorkflowConnections(route.params.workflow_id)
})

const runStatusClasses = computed(() => {
    const baseClasses = 'px-2 py-1 rounded-full text-xs';

    switch(connection.value?.last_run_status) {
        case 'SUCCESS':
            return `${baseClasses} bg-green-100 text-green-800`;
        case 'ERROR':
            return `${baseClasses} bg-red-100 text-red-800`;
        case 'NOT_STARTED':
        default:
            return `${baseClasses} bg-gray-100 text-gray-800`;
    }
})

const formatDateTime = (dateTime) => {
    if (!dateTime) return '';
    return new Date(dateTime).toLocaleString('ru-RU');
}

const runStatusText = computed(() => {
    switch(connection.value?.last_run_status) {
        case 'SUCCESS':
            return 'Успешно';
        case 'ERROR':
            return 'С ошибкой';
        case 'NOT_STARTED':
            return 'Не выполнялся';
        default:
            return 'Не выполнялся';
    }
})


</script>

<template>
<ModalWindowBase v-model="isVisible">
    <template #name>
        <div class="font-bold text-base ml-10">
            Сводка запуска соединения
        </div>
    </template>
    <template #content>
        <div class="bg-white rounded-lg p-6">
            <div class="flex items-center justify-between mb-4">
                <div class="flex items-center">
                    <h2 class="text-lg font-semibold text-gray-700">{{ connection?.name }}</h2>
                </div>
                <div :class="runStatusClasses">
                    <span class="text-sm font-medium">{{ runStatusText }}</span>
                </div>
            </div>
            <div class="border-t border-gray-200 pt-4 mt-4">
                <h3 class="text-md font-medium text-gray-700 mb-2">Последний запуск:</h3>

                <div v-if="connection?.last_run_datetime" class="flex items-center">
                    <span class="text-sm text-gray-600 mr-4">
                      {{ formatDateTime(connection?.last_run_datetime) }}
                    </span>
                    <span :class="runStatusClasses">
                     {{ runStatusText }}
                    </span>
                </div>

                <div v-else class="text-sm text-gray-500">
                    Запуск еще не выполнялся
                </div>
                <div v-if="connection?.last_run_error_message" class="mt-2 p-3 bg-red-50 border border-red-200 rounded-md">
                    <p class="text-sm text-red-700">{{ connection?.last_run_error_message }}</p>
                </div>
            </div>
        </div>
    </template>
</ModalWindowBase>
</template>

<style scoped>

</style>